import styled from "styled-components";

export const MusicInstrumentContainerStyled = styled.div`
  padding: 20px;
  border-radius: 20px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};

  .btn_create {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    white-space: nowrap;
    .w120 {
      margin-left: 8px;
      width: 120px;
    }
    .btn {
      margin-left: 8px;
    }
  }
  .body_table {
    margin-top: 20px;
    border-radius: 1rem;
    padding: 1.25rem 0;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
  }
`;
